import {setDeviceConnectionStatus} from '../../state/slice/iotDevices';
import {dispatch} from '../../state/store';
import uamClientService from './uamClientService';

const getDeviceConnectionStatus = async (dusn, isThrowError) => {
    const status = await uamClientService.getDeviceConnectionStatus(dusn, isThrowError);

    dispatch(setDeviceConnectionStatus(dusn, status));

    return status;
};

export default {
    getDeviceConnectionStatus,
};
